import { UseQueryOptions } from 'react-query'

import { baseAPIPathGuruKS, baseUrlAPIPhicos } from 'configs/api'
import { PHICOS_SESSION_STORAGE_KEY } from 'configs/auth'

import { useQueryApi } from 'utils/api'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

import { SessionPhicos } from 'types/auth'
import { RegionType } from 'types/region-type'

interface ParamsPhicosRedirect {
  regionId: string
  regionType: RegionType
}

export interface ResponsePhicosRedirect {
  redirectUrl: string
}

export const useAPIPhicosRedirect = (params: ParamsPhicosRedirect) =>
  useQueryApi<ResponsePhicosRedirect>(
    `${baseAPIPathGuruKS}/v1/ks/substance-cbt-assessment/redirect`,
    {
      axiosConfig: {
        params,
      },
      queryConfig: {
        enabled: false, // Force trigger by refetch
      },
    }
  )
interface ParamsPhicosCheckQuotaSubstansi {
  seleksi_id: string
  total_diajukan: number
}

export interface ResponsePhicosCheckQuotaSubstansi {
  status: string
  kuota: number
  is_kuota_available: boolean
}

export const useAPIPhicosCheckQuotaSubstansi = (
  params: ParamsPhicosCheckQuotaSubstansi,
  queryConfig: UseQueryOptions<ResponsePhicosCheckQuotaSubstansi> = {}
) => {
  const { data: phicosSession } = useLocalStorage<SessionPhicos>(
    PHICOS_SESSION_STORAGE_KEY,
    {}
  )

  return useQueryApi<ResponsePhicosCheckQuotaSubstansi>(
    `${baseUrlAPIPhicos}/check-kuota-substansi`,
    {
      axiosConfig: {
        params,
        headers: {
          Authorization: `Bearer ${phicosSession.token}`,
        },
      },
      queryConfig,
    }
  )
}
